import { StrictMode } from "react";
import { SanitizedNotice } from "./shell/SanitizedNotice";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import { ToastProvider } from "@salesapp/ui";
import { AuthProvider } from "./shell/AuthProvider";
import { AccessProvider } from "./shell/AccessProvider";
import { ThemeProvider } from "./shell/ThemeProvider";
import { AccountThemeSync } from "./shell/AccountThemeSync";
import { LocaleProvider } from "./shell/LocaleProvider";
import { GuideProvider } from "./guide/GuideProvider";
import { App } from "./App";
import { ErrorBoundary } from "./shell/ErrorBoundary";
import "./theme.css";

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element #root not found in index.html");
}

createRoot(rootElement).render(
  <StrictMode>
    <BrowserRouter>
      <ErrorBoundary>
      <ToastProvider>
        <ThemeProvider>
          <AuthProvider>
            <AccessProvider>
              <LocaleProvider>
              <AccountThemeSync />
              <SanitizedNotice />
              <GuideProvider>
                <App />
              </GuideProvider>
              </LocaleProvider>
            </AccessProvider>
          </AuthProvider>
        </ThemeProvider>
      </ToastProvider>
      </ErrorBoundary>
    </BrowserRouter>
  </StrictMode>,
);
